// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__3wTH4","navText":"Navbar_navText__2qH-k","navLogo":"Navbar_navLogo__39KbX","imgLogo":"Navbar_imgLogo__phA6q"};